var React = require('react');

function BotSays (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"stroke":"#333333"},React.createElement("g",{"transform":"translate(5.000000, 3.000000)"},[React.createElement("path",{"d":"M7,0 L7,0 C10.8659932,-7.10171439e-16 14,3.13400675 14,7 L14,14 C14,16.209139 12.209139,18 10,18 L4,18 C1.790861,18 2.705415e-16,16.209139 0,14 L0,7 C-4.73447626e-16,3.13400675 3.13400675,7.10171439e-16 7,0 Z","fill":"#FFFFFF","key":0}),React.createElement("rect",{"fill":"#DDDDDD","x":"2","y":"5","width":"10","height":"3","rx":"1.5","key":1}),React.createElement("path",{"d":"M7,11 L7,15","key":2})]))));
}

BotSays.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = BotSays;

BotSays.default = BotSays;
